import { Component, Input } from '@angular/core';

// Modèles
import { DOC_TYPE_LABELS, DocArticleType } from '../../../models/documentation/documentation.types';

/**
 * La nature d'un article — guide, comprendre, référence, dépannage — sous sa
 * forme lisible : un point de couleur et le mot.
 *
 * Elle revient sur cinq écrans (accueil, résultats de recherche, panneau « ? »,
 * bandeau d'article, blocs de fin) et le code couleur doit s'y lire à
 * l'identique : d'où un composant plutôt qu'un balisage recopié. Les couleurs
 * vivent dans `src/styles/documentation.scss`, les mots dans
 * `DOC_TYPE_LABELS` — une nature ajoutée au manuel se déclare aux deux endroits,
 * et le `Record` typé le rappelle à la compilation.
 *
 * Quand il n'y a pas la place du mot (une ligne de question, un lien de fin),
 * c'est le point seul qui sert : classe `doc-type-dot doc-type-dot--<type>`,
 * sans passer par ce composant.
 */
@Component({
    selector: 'app-documentation-type-badge',
    imports: [],
    template: `
        <span class="doc-type-badge doc-type-badge--{{ type }}">
            <span class="doc-type-dot doc-type-dot--{{ type }}"></span>{{ label }}
        </span>
    `,
})
export class DocumentationTypeBadgeComponent {

    /*----------------------------------------------------------------------------------------
     * Données
     ----------------------------------------------------------------------------------------*/

    private _type: DocArticleType = 'guide';
    public get type(): DocArticleType {
        return this._type;
    }
    @Input() public set type(value: DocArticleType) {
        this._type = value;
    }

    /*----------------------------------------------------------------------------------------
     * Accesseurs
     ----------------------------------------------------------------------------------------*/

    public get label(): string {
        return DOC_TYPE_LABELS[this._type] ?? '';
    }
}
